import {BaseEntity} from '../common/base-entity';
import {MatterDocument} from './matter-document';


export type DocSharingMessageType = 'SHARED_DOCUMENT' | 'REVOKED_DOCUMENT' | 'REVOKED_PACKAGE' | 'DECLINED_PACKAGE';

export class DocSharingMessage extends BaseEntity{
    id: number;
    messageSubject: string;
    message: string;
    recipientUserId: number;
    messageReadTime: string;
    sharedDocumentPackageId: number;
    lastUpdatedTimeStamp: string;
    messageType: DocSharingMessageType;
    documentIdsIncludedInMessage: number[];
    attachedDocuments: MatterDocument[];
    guid: string; //it is packageGuid
}
